export default (params) => ({
  trigger: {
    name: 'product_type_section.open_upsell_dropdown',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      number_of_items: {
        type: 'integer',
      },
    },
    event: {
      name: 'select_item_list',
      params: {
        sub_feature: 'upsell_collection',
        item_list_id: null,
        item_list_name: null,
      },
    },
  },
});
